module.exports = __webpack_public_path__ + "img/42.fff6bb66.jpg";